import { Menu, Tooltip } from '@mantine/core';
import { IconArrowBack } from '@tabler/icons-react';
import { useConfirmWithMessage } from 'components/modals/confirm-with-message/ConfirmWithMessageProvider';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { noop } from 'lodash';
import useReopenAction from 'components/tables/data/revision/actions/hooks/use-reopen-action';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the user who has the permission to reopen the revision.
 */
export default function ReopenAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { reopenRevision } = useReopenAction();
  const { confirmWithMessage } = useConfirmWithMessage();

  /**
   * Confirms the reopening of the revision.
   */
  const confirmReopenRevision = () =>
    confirmWithMessage({
      title: revision.kind === 'revision' ? 'Vrátenie revíznej správy' : 'Vrátenie formulára',
      message:
        revision.kind === 'revision'
          ? 'Naozaj si prajete vrátiť túto revíznu správu?'
          : 'Naozaj si prajete vrátiť tento formulár?',
      onConfirmWithMessage: (reason?: string) => reopenRevision({ revision, reason, onStatusChange }),
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Vrátiť" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" onClick={confirmReopenRevision}>
          <IconArrowBack stroke={1.5} size={24} />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button
        size="md"
        onClick={confirmReopenRevision}
        leftIcon={<IconArrowBack stroke={1.5} size={24} />}
        variant="secondary"
        w={188}
      >
        Vrátiť
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={confirmReopenRevision} icon={<IconArrowBack stroke={1.5} size={24} />}>
      Vrátiť
    </Menu.Item>
  );
}
